/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactEmailFromJSON, FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactEmailToJSON, } from './FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactEmail';
/**
 * Check if a given object implements the FxIdDomainSettingsPublicWebClientConfigOptionsLegalContact interface.
 */
export function instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLegalContact(value) {
    if (!('LegalName' in value) || value['LegalName'] === undefined)
        return false;
    return true;
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'LegalName': json['LegalName'],
        'OgrnNumber': json['OgrnNumber'] == null ? undefined : json['OgrnNumber'],
        'InnNumber': json['InnNumber'] == null ? undefined : json['InnNumber'],
        'Email': json['Email'] == null ? undefined : FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactEmailFromJSON(json['Email']),
    };
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'LegalName': value['LegalName'],
        'OgrnNumber': value['OgrnNumber'],
        'InnNumber': value['InnNumber'],
        'Email': FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactEmailToJSON(value['Email']),
    };
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsLegalContact.js.map